/**
 * The namespace of the i18n/translation keys.
 *
 * @type {string}
 */
export const _TNS = 'deepLinking';
